<template>
  <b-row>
    <b-col cols="12" md="4">
      <custom-input
        v-model="innerValue.code"
        :name="$gettext('code')"
      />
    </b-col>
    <b-col cols="12" md="4">
      <custom-input
        v-model="innerValue.name"
        :name="$gettext('name')"
      />
    </b-col>
  </b-row>
</template>

<script>
import vModelMixin from '@/shared/mixins/v-model'

export default {
  mixins: [vModelMixin],
}
</script>
